import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
}

const WELCOME_MESSAGE: ChatMessage = {
  role: 'assistant',
  content:
    '¡Hola! Soy el asistente virtual de ChircalNet. Puedo ayudarte con información sobre planes, cobertura y soporte. ¿En qué puedo ayudarte?',
};

@Injectable({ providedIn: 'root' })
export class ChatService {
  private readonly apiUrl = `${environment.apiUrl}/ai-chat`;

  messages = signal<ChatMessage[]>([WELCOME_MESSAGE]);
  loading = signal(false);

  constructor(private readonly http: HttpClient) {}

  async sendMessage(text: string): Promise<void> {
    const trimmed = text.trim();
    if (!trimmed || this.loading()) return;

    const history = this.messages().slice(-10);
    this.messages.update((msgs) => [...msgs, { role: 'user', content: trimmed }]);
    this.loading.set(true);

    try {
      const body = {
        userMessage: trimmed,
        messages: history,
      };
      const res = await firstValueFrom(
        this.http.post<{ reply: string }>(this.apiUrl, body),
      );
      this.messages.update((msgs) => [
        ...msgs,
        { role: 'assistant', content: res.reply },
      ]);
    } catch {
      this.messages.update((msgs) => [
        ...msgs,
        {
          role: 'assistant',
          content:
            'Lo siento, no pude procesar tu mensaje en este momento. Inténtalo de nuevo en unos segundos.',
        },
      ]);
    } finally {
      this.loading.set(false);
    }
  }
}
